import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconSelect = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" d="M7.838 4.398a3.9 3.9 0 0 1 1.713.2l.27.107h.002l47.68 21.06.002.001.27.132c.527.285.981.688 1.327 1.178l.164.25.142.266a3.876 3.876 0 0 1-2.199 5.377l-.287.087-17.896 4.71h.001a1.75 1.75 0 0 0-1.245 1.247v.001l-4.71 17.895v.002a3.875 3.875 0 0 1-7.159.848l-.132-.27v-.001L4.71 9.808 4.707 9.8a3.88 3.88 0 0 1-.255-2.274l.066-.284a3.9 3.9 0 0 1 1.006-1.736l.214-.199a3.9 3.9 0 0 1 1.812-.866zm21.456 51.146 4.62-17.548a5.75 5.75 0 0 1 4.093-4.097h.002l17.549-4.62L8.503 8.495z" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconSelect.displayName = 'IconSelect';